import { render } from "./PropertyCard.vue?vue&type=template&id=622f48a2&ts=true"
import script from "./PropertyCard.vue?vue&type=script&lang=ts"
export * from "./PropertyCard.vue?vue&type=script&lang=ts"

import "./PropertyCard.vue?vue&type=style&index=0&id=622f48a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__